import { PureComponent } from 'react';
import Routes, { Router } from '../routes';
import { getMessages } from './i18n';

const getServerEventsPath = async (locale) => {
  const { eventsPath } = await getMessages(locale);

  return eventsPath;
};

export default class EventPage extends PureComponent {
  static async getInitialProps({
    res, req, query: { eventsPath, slug, prefix },
  }) {
    const route = slug ? 'event' : 'events';
    const actualEventsPath = req ? await getServerEventsPath(req.locale)
      // eslint-disable-next-line no-underscore-dangle
      : window.__NEXT_DATA__.props.messages.eventsPath;
    const queryWithoutPrefix = slug
      ? { eventsPath: actualEventsPath, slug }
      : { eventsPath: actualEventsPath };
    const query = prefix
      ? { ...queryWithoutPrefix, prefix } : queryWithoutPrefix;

    if (eventsPath !== actualEventsPath) {
      if (res) {
        res.writeHead(301, {
          Location: Routes.findAndGetUrls(
            route,
            query,
          ).urls.as,
        });
        res.end();
      } else {
        Router.pushRoute(route, query);
      }
    }

    return {};
  }
}
